import {AuthError, AuthService} from '@services/auth.service';
import {
    fetchReferringPlatforms,
    setupEngineAndAxiosInterceptors
} from "@helpers/api-helper";
import UserAppResource from "@sellers-shield-home-protection/ss-core-js/src/AppResources/UserAppResource";
import agentLicenseService from "@services/agentLicense.service";
import {isMagicLicense, VALID_LICENSE} from "@helpers/license";

const actions = {

    async fetchMe() {
        const {
            data: {
                data: {
                    user: me,
                },
            },
        } = await AuthService.me();

        if (me?.uuid) {
            console.log('AuthStore.js actions fetchMe() found a user', me);
            this._me = new UserAppResource(me, true);
            this._me.uuid = me.uuid;

            return this._me;
        } else {
            this._me = {};
        }

        return null;
    },

    async setTokensGetMe(accessToken, refreshToken, getUserInfo = true) {

        this._authenticating = false;
        this._accessToken = accessToken || '';
        this._refreshToken = refreshToken || '';

        if (accessToken) {
            setupEngineAndAxiosInterceptors(accessToken);

            if (getUserInfo) {
                return await this.fetchMe();
            }
        } else {
            this._me = {};
        }

        return null;
    },

    async login(email, password) {
        try {
            this.logout();

            const {accessToken, refreshToken} = await AuthService.login(email, password);

            return await this.setTokensGetMe(accessToken, refreshToken);
        } catch (error) {
            this._authenticating = false;

            if (error instanceof AuthError) {
                this._authenticationErrorCode = error['errorCode'];
                this._authenticationError = error.message;
            }

            throw error;
        }

        return null;
    },

    async register(data) {
        try {
            return await AuthService.register(data);
        } catch (error) {
            this._authenticating = false;

            if (error instanceof AuthError) {
                this._authenticationErrorCode = error['errorCode'];
                this._authenticationError = error.message;
            }

            throw error;
        }
    },

    logout() {
        try {
            let sspToken = this._sspToken;

            AuthService.logout();
            this.$reset();
            this._sspToken = sspToken;

            //make sure
            this._me = {};
            this._accessToken = '';
            this._refreshToken = '';
        } catch (e) {
        }
    },

    async revalidateAndStoreTxLicense() {
        try {
            console.log('revalidateAndStoreTxLicense begin');
            if (this.meTxLicense?.uuid) {
                console.log('revalidateAndStoreTxLicense found a license', this.meTxLicense?.uuid);
                if(!isMagicLicense(this.meTxLicense?.number)) {
                    await agentLicenseService.revalidateLicense(this.meTxLicense?.uuid);
                }
                
            }
        } catch(e) {
            console.error('revalidateAndStoreTxLicense error', e);
        }
    },

    async refreshTokenRequest() {
        try {
            const {accessToken, refreshToken} = await AuthService.refreshToken(this._refreshToken);

            await this.setTokensGetMe(accessToken, refreshToken, !this._me?.uuid);
        } catch (error) {
            throw error;
        }
    },

    async thirdPartyAuthorize(clientUuid, authCallbackUrl) {
        try {
            return await AuthService.thirdPartyAuthorize(clientUuid, authCallbackUrl);
        } catch (error) {
            return error;
        }
    },

    async thirdPartyLogin(thirdPartySlug, token) {
        try {
            this.logout();

            const {
                accessToken,
                refreshToken,
                isRevoked,
                thirdPartyUuid,
                clientUuid
            } = await AuthService.thirdPartyLogin(thirdPartySlug, token);

            if (accessToken && thirdPartyUuid) {
                this._thirdPartyUuid = thirdPartyUuid;
                this._clientUuid = clientUuid;

                await this.setTokensGetMe(accessToken, refreshToken);

                return !isRevoked;
            }
        } catch (error) {
            this._authenticating = false;

            if (error instanceof AuthError) {
                this._authenticationErrorCode = error['errorCode'];
                this._authenticationError = error.message;
            }

            throw error;
        }

        return false;
    },

    async getThirdPartyPlatformList(runPublic) {
        let list = await fetchReferringPlatforms({
            active: true,
            clientUuid: {
                operator: 'isNotNull',
                value: 'isNotNull',
            }
        }, runPublic, true, 1000);

        this._thirdPartyPlatformList = list || [];
    },

    setThirdPartyUuid(value) {
        this._thirdPartyUuid = value || '';
        if (!this._thirdPartyUuid) {
            this._clientUuid = '';
        }
    },

    setThirdPartyInternRedirect(value) {
        this._thirdPartyInternRedirect = value || '';
    },

    setClientUuid(value) {
        this._clientUuid = value || '';
    },

    setSellerAgent(value) {
        this._sellerAgent = value;
    },

    toggleOnProxyByV2() {
        this._proxyByV2 = true;
    },

    toggleOffProxyByV2() {
        this._proxyByV2 = false;
    },

    TOGGLE_PROXY_BY_V2() {
        this._proxyByV2 = !this._proxyByV2;
    },

    SET_ME(value) {
        this._me = value;
    },
};

export default actions;